export const checkTapit = () => {
    document.addEventListener('tapitLoad', (e: any) => {
        let refHeader = document.querySelector('#logoutTapit')
        if (!e.detail.isLogout && refHeader) {
            refHeader.innerHTML = e.detail.user.firstName.split(' ')[0]
        }
    })
}